import React from "react";
import styled from "styled-components";

const StyledForm = styled.form`
    display: flex;
`;

const StyledInput = styled.input`
    flex-grow: 1;
`;

const StyledButton = styled.button`
    margin-left: 10px;
    color: white !important;
`;

const SearchByZip = ({ searchByZip }) => (
    <StyledForm
        onSubmit={() =>
            searchByZip(document.getElementById("searchByZip").value)
        }
    >
        <StyledInput
            id="searchByZip"
            placeholder="Enter your ZIP Code"
            className="field form-control success-field"
        />
        <StyledButton
            id="searchByZipBtn"
            className="btn btn btn-primary btn-default"
            type="submit">
            Search
        </StyledButton>
    </StyledForm>
);

export default SearchByZip;



// WEBPACK FOOTER //
// ./components/index/SearchByZip.jsx